import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-12 md:py-20 bg-yoga-purple-900 text-white relative overflow-hidden" data-id="element-145">
      <div className="absolute inset-0 bg-hero-pattern opacity-50" data-id="element-146"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-147">
        <motion.div className="max-w-3xl mx-auto bg-white/10 backdrop-blur-md rounded-2xl md:rounded-3xl p-6 md:p-12 border border-white/20 text-center shadow-2xl" initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-148">
          <div className="inline-flex items-center justify-center p-3 md:p-4 bg-yoga-gold/20 rounded-full mb-4 md:mb-6" data-id="element-149">
            <ShieldCheck className="w-8 h-8 md:w-12 md:h-12 text-yoga-gold" data-id="element-150" />
          </div>

          <h2 className="text-2xl md:text-4xl font-serif font-bold mb-4 md:mb-6 text-yoga-gold-300" data-id="element-151">
            GARANTÍA YOGA RESUELTA — 7 DÍAS
          </h2>

          <p className="text-base md:text-2xl font-light mb-5 md:mb-8 leading-relaxed" data-id="element-152">
            Abrís los 6 tomos. Revisás los 6 bonos. Los usás en tu clase si
            querés. Si en 7 días no es lo que esperabas:{' '}
            <strong className="text-white font-bold" data-id="element-153">
              Te devolvemos el 100%. Sin preguntas. Sin formularios. Sin drama.
            </strong>
          </p>

          <div className="bg-black/20 rounded-xl p-4 md:p-6 border border-white/10" data-id="element-154">
            <p className="text-yoga-purple-100 text-xs md:text-base" data-id="element-155">
              La confianza que tenemos en YOGA RESUELTA nos permite hacer esa
              promesa sin dudar. Más de 500 profes de Yoga de todo el país ya lo
              saben. La tasa de devoluciones es menor al 1%.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}